<div class="recovery-viewport w-100 bc-mono-white b-logo" fxLayout="column">
    <div fxLayout="column" fxLayoutAlign="start center" class="recovery-center w-100">
        <div fxLayout="column" fxLayoutAlign="center center"
             class="recovery-card p-32 main-shadow radius-16">
            @if (iconType === 'success') {
                <ui-kit-svg class="status-icon" name="ic_checkmark_circle"/>
            } @else {
                <img class="status-icon" src="assets/images/link-expired.png" alt=""/>
            }
            <div class="h2-semi-bold text-center mt-16">{{ titleText | translate }}</div>
            <div class="t3 c-primary-gray-600 text-center mt-16">{{ subtitleText | translate }}</div>
            <ui-kit-button class="mt-32"
                           type="secondary"
                           buttonType="button"
                           [label]="'i18n_af_buttonToLogin' | translate"
                           (clickListener)="goToLogin()"/>
        </div>
    </div>
</div>
